export const Locale = {
  english: "en-US",
  italian: "it-IT",
  japanese: "ja-JP",
  frenchCanadian: "fr-CA",
  korean: "ko-KR",
  spanish: "es-ES",
  german: "de-DE",
  french: "fr-FR",
  chinese: "zh-CN",
  thai: "th-TH",
} as const;

export type LocaleType =
  | "en-US"
  | "it-IT"
  | "ja-JP"
  | "fr-CA"
  | "ko-KR"
  | "es-ES"
  | "de-DE"
  | "fr-FR"
  | "zh-CN"
  | "th-TH";
